// src/app/profile/components/ProfileHeader.tsx
'use client';

import React from 'react';

type ProfileHeaderProps = {
  title?: string;
  subtitle?: string;
};

export default function ProfileHeader({ title = 'Your Profile', subtitle }: ProfileHeaderProps) {
  return (
    <header className="flex items-center justify-between">
      <div>
        <h1 id="profile-section-title" tabIndex={-1} className="text-2xl font-semibold text-foreground">{title}</h1>
        {subtitle && (
          <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>
        )}
      </div>
    </header>
  );
}
